import React, { useContext } from 'react';
import FooterLogo from './FooterLogo';
import { Box, Divider, makeStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';
import { THEME_TYPES } from '../../../constants/ThemeOptions';
import { NavLink } from 'react-router-dom';
import IntlMessages from '../../../utils/IntlMessages';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnRoot: {
    [theme.breakpoints.down('xs')]: {
      padding: '6px 12px',
      fontSize: 11,
    },
  },
  loginSection: {
    display: 'flex',
    alignItems: 'center',
    '& > .MuiDivider-root': {
      height: 14,
      marginLeft: 8,
      marginRight: 8,
      backgroundColor: theme.palette.text.secondary,
    },
  },
}));

const Footer = props => {
  const classes = useStyles();
  const { themeType } = useContext(AppContext);
  const date = new Date();

  return (
    <Box className={classes.root} {...props}>
      <Box display="flex" alignItems="center">
        <Hidden xsDown>
          <FooterLogo mr={5} color={themeType === THEME_TYPES.DARK ? 'white' : ''} />
        </Hidden>
        <Box fontSize={{ xs: 12, sm: 14 }} component="p" color="text.disabled">
          Copyright Market Action © {date.getFullYear()}
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Box className={classes.loginSection}>
          <NavLink to="/signin" style={{ color: '#ffffff', opacity: 0.3 }}>
            Login
          </NavLink>
          <Divider className="Cmt-divider" orientation="vertical" />
          <NavLink to="/privacy-policy" style={{ color: '#ffffff', opacity: 0.3 }}>
            <IntlMessages id="footer.privacyPolicy" />
          </NavLink>
          <Divider className="Cmt-divider" orientation="vertical" />
          <NavLink to="/faq" style={{ color: '#ffffff', opacity: 0.3 }}>
            <IntlMessages id="footer.faq" />
          </NavLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
